import { Component } from "react";

import "./styles.scss";

export default function CompanyInfo({ brand }) {
  if (brand === "vw") {
    return (
      <div className="companyInfo">
        <div className="infoLine">San Martin Sur 600, Godoy Cruz, tel: +54 261 4439300</div>
        <div className="infoLine">Avenida Mitre 721, San Rafael, Mendoza, tel: +54 260 4424951</div>
        <div className="infoLine">
          Paula Albarracín de Sarmiento Nte. 699, San Juan, tel: 0810 666 1033
        </div>
      </div>
    );
  }

  return (
    <div className="companyInfo">
      <div className="infoLine">Llamá al +54 261 4439300</div>
      <div className="infoLine">San Martín Sur 600. Godoy Cruz. Mendoza</div>
    </div>
  );
}
